import React from "react";
import Header from "../../components/Header";

const Cancellation = () => {
  return (
    <>
    <Header/>
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className=" relative pt-[150px] md:pt-[70px]">
         <h1
  data-aos="fade-up"
  className="text-4xl md:text-6xl font-black text-[#3F3D3A] leading-tight text-center"
>
  Cancellation
  <span className="bg-gradient-to-r from-[#D4CB2F] via-[#E6DD57] to-[#55534F] bg-clip-text text-transparent">
    {" "}Policy
  </span>
</h1>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[100px]" data-aos="fade">
        <div className="theme-container mx-auto w-full text-paragraph">
          <i className="text-[14px] mb-2 inline-block font-semibold">
            Last updated on July 10th 2026
          </i>
          <p className="font-medium mb-2">
            S Meera Health believes in helping its customers as far as possible,
            and has therefore a liberal cancellation policy. Under this policy:
          </p>
          <ul>
            <li className="mb-2">
              1. Cancellations will be considered only if the request is made
              within 7 days of placing the order. However, the cancellation
              request may not be entertained if the orders have been
              communicated to the vendors/merchants and they have initiated the
              process of shipping / delivering / Using them.
            </li>
            <li className="mb-2">
              2. S Meera Health does not accept cancellation requests for orders
              already initiated or in transit or completed. However,
              refund/replacement can be made if the customer establishes that
              the quality of product/service delivered is not good.
            </li>
            <li className="mb-2">
              3. In case of improper delivery of services or inaccurate results,
              please report the same to our Customer Service team. The request
              will, however, be entertained once the health provider has checked
              and determined the same at his own end. This should be reported
              within 7 days of receipt of the product/service.
            </li>
            <li className="mb-2">
              4. In case you feel that the product/service received is not as
              promised by us or as per your expectations, you must bring it to
              the notice of our customer service within 7 days of receiving the
              product/service. The Customer Service Team after looking into your
              complaint will take an appropriate decision.
            </li>
            <li className="mb-2">
              5. In case of any Refunds approved by the S Meera Health, it’ll
              take 6-8 days for the refund to be processed to the end customer.
            </li>
            <li className="mb-2">
              6. In the event that a User/ costumer requests a refund but the
              service has already been initiated or not cancelled in time, the
              fee shall be non-refundable. This fee is charged by a third-party
              logistics partner and cannot be reclaimed once the service is
              booked. If the service or plan is not cancelled, or if
              cancellation is not possible due to the service already being
              dispatched or delivered, the corresponding amount will be deducted
              from the total refundable amount.
            </li>
          </ul>
        </div>
      </section>
      {/* blog end  */}
    </main>
    </>
  );
};

export default Cancellation;
